import { useInfiniteQuery } from "@tanstack/react-query";
import { Club } from "@/TS/Interfaces/global_interfaces";
interface ClubsPageData {
  clubs: Club[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}
interface UseClubsInfiniteQueryOptions {
  pageSize?: number;
  staleTime?: number;
  enabled?: boolean;
  theme?: string;
  format?: string;
  location?: {
    latitude: number;
    longitude: number;
  } | undefined;
}
export function useClubsInfiniteQuery(options: UseClubsInfiniteQueryOptions = {}) {
  const {
    pageSize = options.pageSize || 10,
    staleTime = options.staleTime || 5 * 60 * 1000,
    // 5 minutes
    enabled = options.enabled || true,
    theme = options.theme || "",
    format = options.format || "",
    location = options.location || {
      latitude: null,
      longitude: null
    }
  } = options;
  return useInfiniteQuery<ClubsPageData>({
    queryKey: ["clubs", {
      pageSize,
      theme,
      format,
      location
    }],
    queryFn: async ({
      pageParam
    }) => {
      const page = pageParam as number || 1;
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        ...(theme && {
          theme
        }),
        ...(format && {
          format
        })
      });
      if (location?.latitude && location?.longitude) {
        params.append("latitude", location.latitude.toString());
        params.append("longitude", location.longitude.toString());
      }
      const response = await fetch(`/api/clubs-list?${params.toString()}`, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des clubs");
      }
      return response.json();
    },
    initialPageParam: 1,
    enabled,
    staleTime,
    getNextPageParam: lastPage => {
      // Vérifier si on a une page suivante ET qu'on n'a pas atteint la dernière page
      const nextPage = lastPage.hasNextPage ? lastPage.currentPage + 1 : undefined;
      return nextPage;
    },
    // Optimisations pour de meilleures performances
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 3,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
}